import { Component, OnInit } from '@angular/core';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import { StorageService } from '../../../shared/security/StorageService';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { BadQuestionnaireModel } from '../../../model/badQuestionnaireModel';
import * as $ from 'jquery';

@Component({
  selector: 'app-questionnaire-broker-audit-declaration',
  templateUrl: './questionnaire-broker-audit-declaration.component.html',
  styleUrls: ['./questionnaire-broker-audit-declaration.component.css']
})
export class QuestionnaireBrokerAuditDeclarationComponent implements OnInit {
  workflow: WorkflowModel = new WorkflowModel();
  startFunction: StartFunctionResponseModel;
  badQuestionnaireDataModel : BadQuestionnaireModel = new BadQuestionnaireModel();

  constructor(private router: Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private storageService: StorageService,
    private startFunctionService: StartFunctionService,
    private spinner: SpinnerService,
    private currentPageWatcher: CurrentPageWatcherService) { 

    this.workflow  =this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;

    }

  ngOnInit() {

    this.startFunction = this.storageService.getStartFunctionData();
    //back browser button from bad questionnaire section
    if(this.startFunction.Workflow.Steps[1].checked == false){
      this.router.navigate(['/brokerageInformation']);
    }
    else {
      this.brokerAuditDeclarationService.getBrokerAuditDeclarationQuestionnaire(this.workflow.WorkflowID).subscribe(
        (badQuestData: BadQuestionnaireModel) => {
          this.badQuestionnaireDataModel = badQuestData;
          this.brokerAuditDeclarationService.badQuestionnaireDataModel = this.badQuestionnaireDataModel;
          this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdatedQuestionnaire().emit(this.badQuestionnaireDataModel.LastUpdated);

          console.log("this.badQuestionnaireDataModel.Sections : ", this.badQuestionnaireDataModel.Sections);
          this.getBADQuestionnaireSectionIdList();

          //next section = first section in the list = min number of this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList
          let nextSectionId = Math.min.apply(null, this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList);
          //delete section from list
          this.router.navigate(['/questionnaireAuditDeclarationSection', nextSectionId]);
        });
    }
   
  }

  getBADQuestionnaireSectionIdList() {
    this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList = [];

    //get enabled sections
    this.badQuestionnaireDataModel.Sections.forEach(sect=>{
      if(sect.EnabledForAnswering){
        this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList.push(sect.SectionID);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/questionnaire-broker-audit-declaration.component.ts